<template>
<div class="chapter">
<div class="inner_page">
<p class="sink"> </p>
<p class="center ">
<b>Cezary Strzybisz</b>
</p>
<h1 class="chaptertitle parttitle">NECROBES</h1>
<p class="center ">
<b>139 Reproductions</b>
</p>
<div class="timebreak "> </div>
<p class="center ">Introduction by Stanislaw Ertel</p>
<p class="sink"> </p>
<p class="center ">
<b>Zodiac Publishers</b>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?5cdc00ea